import type { ComponentProps } from "react";
import { LanguageSwitch as SharedLanguageSwitch } from "@repo/ui/components/ui/language-switch";

type LanguageSwitchProps = ComponentProps<typeof SharedLanguageSwitch>;

const LanguageSwitch = (props: LanguageSwitchProps) => {
	return <SharedLanguageSwitch {...props} withViewportPadding />;
};

export { LanguageSwitch };
